import React from 'react';
/* eslint-disable */
export function Sms(props: React.ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M17 4.5C17 3.54297 16.207 2.75 15.25 2.75H4.75C3.76562 2.75 3 3.54297 3 4.5V12.375C3 13.3594 3.76562 14.125 4.75 14.125H7.375V16.4219C7.375 16.6953 7.67578 16.8594 7.89453 16.6953L11.3125 14.125H15.25C16.207 14.125 17 13.3594 17 12.375V4.5Z"
        fill="currentColor"
      />
    </svg>
  );
}
